import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import LoadingAnimation from "../LoadingAnimation";
const VerificationForm = () => {
  const navigate = useNavigate();
  const { itemId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [verificationCallDate, setVerificationCallDate] = useState();
  const [callStatus, setCallStatus] = useState();
  const [planExplanation, setPlanExplanation] = useState("");
  const [prePaidPlanExplanation, setPrePaidPlanExplanation] = useState("");
  const [wifiAvailable, setWifiAvailable] = useState("");
  const [serviceDetail, setServiceDetail] = useState("");
  const [tenure, setTenure] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [lease, setLease] = useState("");
  const [siteDetail, setSiteDetail] = useState("");
  const [replacementNew, setReplacementNew] = useState("");
  const [installationDate, setInstallationDate] = useState(null);
  const [installationDetail, setInstallationDetail] = useState("");
  const [ownerName, setOwnerName] = useState();
  const [ownerNumber, setOwnerNumber] = useState();
  const [managerName, setManagerName] = useState();
  const [managerNumber, setManagerNumber] = useState();
  const [financeManagerName, setFinanceManagerName] = useState();
  const [financeManagerNumber, setFinanceManagerNumber] = useState();
  const [isSameAsManager, setIsSameAsManager] = useState(false);
  const [isSameAsFinanceManager, setIsSameAsFinanceManager] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [newBillingName, setnewBillingname] = useState()
  const [newGst, setnewGst] = useState()
  const [ischanged, setischanged] = useState(false)
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const [error, setError] = useState("");




  useEffect(() => {
    const fetchVerificationDetails = async () => {
      if (!itemId) return;

      setIsLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/view-verification-form`,
          { preOrderId: itemId }
        );
        const formatDate = (isoDate) => {
          if (!isoDate) return "";
          return new Date(isoDate).toISOString().split("T")[0]; // Extracts only "YYYY-MM-DD"
        };
        // console.log(response.data.data);
        const data = response.data.data;
        if (data && Object.keys(data).length > 0) {
          setVerificationCallDate(formatDate(data.verificationCallDate) || "");
          setCallStatus(data.callStatus || "");
          setPlanExplanation(data.planExplanation || "");
          setPrePaidPlanExplanation(data.prePaidPlanExplanation || "");
          setWifiAvailable(data.wifiAvailable || "");
          setServiceDetail(data.serviceDetail || "");
          setTenure(data.tenure || "");
          setPaymentMode(data.paymentMode || "");
          setPropertyType(data.propertyType || "");
          setLease(data.lease || "");
          setSiteDetail(data.siteDetail || "");
          setReplacementNew(data.replacementNew || "");
          setInstallationDate(formatDate(data.installationDate) || "");
          setInstallationDetail(data.installationDetail || "");
          setOwnerName(data.ownerName || "");
          setOwnerNumber(data.ownerNumber || "");
          setManagerName(data.managerName || "");
          setManagerNumber(data.managerNumber || "");
          setFinanceManagerName(data.financeManagerName || "");
          setFinanceManagerNumber(data.financeManagerNumber || "");
          setnewBillingname(data.newBillingName || "")
          setnewGst(data.newGst || "")
          setIsUpdate(true);
        }
      } catch (error) {
        console.error("Error fetching verification details:", error);
        alert("Failed to fetch verification details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchVerificationDetails();
  }, [itemId]);
  useEffect(() => {
    if (itemId) {
      axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/preexistingcustomer/${itemId}`)
        .then((res) => {
          setischanged(res.data.exists)
        })
        .catch((err) => {
          console.error("Error checking customer:", err);
        });
    }
  }, [itemId]);



  const handleGstChange = (e) => {
    const value = e.target.value.toUpperCase();
    setnewGst(value);

    if (value && !gstRegex.test(value)) {
      setError("Invalid GST format. Example: 27ABCDE1234F1Z5");
    } else {
      setError("");
    }
  };

  const handleCallStatusChange = (status) => {
    setCallStatus(status);
  };

  const handlePlanExplanationChange = (status) => {
    setPlanExplanation(status);
  };

  const handlePrePaidPlanExplanationChange = (status) => {
    setPrePaidPlanExplanation(status);
  };

  const handleWifiAvailableChange = (status) => {
    setWifiAvailable(status);
  };

  const handleServiceDetailChange = (status) => {
    setServiceDetail(status);
  };

  const handleTenureChange = (status) => {
    setTenure(status);
  };

  const handlePaymentModeChange = (status) => {
    setPaymentMode(status);
  };

  const handlePropertyTypeChange = (status) => {
    setPropertyType(status);
  };

  const handleSiteDetailChange = (status) => {
    setSiteDetail(status);
  };

  const handleReplacementNewChange = (status) => {
    setReplacementNew(status);
  };
  const handleCheckboxChange1 = () => {
    if (ownerName === "" || ownerNumber === "") {
      alert("Please Enter Owner Details");
      return;
    }
    setIsSameAsManager(!isSameAsManager);
    if (!isSameAsManager) {
      setManagerName(ownerName);
      setManagerNumber(ownerNumber);
    } else {
      setManagerName("");
      setManagerNumber("");
    }
  };

  const handleCheckboxChange2 = () => {
    if (ownerName === "" || ownerNumber === "") {
      alert("Please Enter Owner Details");
      return;
    }
    setIsSameAsFinanceManager(!isSameAsFinanceManager);
    if (!isSameAsFinanceManager) {
      setFinanceManagerName(ownerName);
      setFinanceManagerNumber(ownerNumber);
    } else {
      setFinanceManagerName("");
      setFinanceManagerNumber("");
    }
  };

  const saveVerificationDetails = async () => {
    if (
      !verificationCallDate ||
      !callStatus ||
      !ownerName ||
      !ownerNumber
    ) {
      alert("Please fill all * fields!");
      return;
    }
    if (newGst) {
      if (!gstRegex.test(newGst)) {
        alert("Issue in GST Number");
        return;
      }
    }

    setIsLoading(true);

    try {
      const preOrderData = {
        preOrderId: itemId,
        verificationCallDate,
        callStatus,
        planExplanation,
        prePaidPlanExplanation,
        wifiAvailable,
        serviceDetail,
        tenure,
        paymentMode,
        propertyType,
        lease,
        siteDetail,
        replacementNew,
        installationDate,
        installationDetail,
        ownerName,
        ownerNumber,
        managerName,
        managerNumber,
        financeManagerName,
        financeManagerNumber,
        newBillingName,
        newGst
      };
      if (itemId !== undefined) {
        const preOrderResponse = await axios.put(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/verification-form`,
          preOrderData
        );
        const googleSheetResponse = await axios.post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/google-sheets/verification-form`,
          { verification_details: preOrderData }
        );
        setIsLoading(false);
        alert(preOrderResponse.data.message);
        navigate("/home");
      }
    } catch (error) {
      alert(
        "An error occurred while saving verification details. Please try again after some time."
      );
      setIsLoading(false);
      navigate("/home");
    }
  };




  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-2xl">
        <h1 className="text-3xl font-bold text-center mb-6">
          Verification Form
        </h1>
        <div className="space-y-4">
          <div>
            <label htmlFor="verificationCallDate" className="block font-medium">
              Verification Call Date:<span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              id="verificationCallDate"
              name="verificationCallDate"
              className="w-full border border-gray-300 rounded-lg p-2 mt-1"
              value={verificationCallDate}
              onChange={(e) => setVerificationCallDate(e.target.value)}
              placeholder="Enter Installation Remark"
              required
            />
          </div>
          <div>
            <label htmlFor="callStatus" className="block font-medium">
              Call Status<span className="text-red-500">*</span>
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {[
                "Received",
                "Call back",
                "Not received",
                "Not to call",
                "Existing Customer",
                "Cancel",
              ].map((status) => (
                <label key={status} className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="callStatus"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={callStatus === status}
                    onChange={() => handleCallStatusChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="planExplanation" className="block font-medium">
              Plan Explanation
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["Yes", "No"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="planExplanation"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={planExplanation === status}
                    onChange={() => handlePlanExplanationChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label
              htmlFor="prePaidPlanExplanation"
              className="block font-medium"
            >
              Prepaid Plan
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["Explained", "Not Explained"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="prePaidPlanExplanation"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={prePaidPlanExplanation === status}
                    onChange={() => handlePrePaidPlanExplanationChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="wifiAvailable" className="block font-medium">
              Wi-Fi Availability?
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["Yes", "No"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="wifiAvailable"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={wifiAvailable === status}
                    onChange={() => handleWifiAvailableChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="serviceDetail" className="block font-medium">
              Service Detail?
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["Yes", "No"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="serviceDetail"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={serviceDetail === status}
                    onChange={() => handleServiceDetailChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="tenure" className="block font-medium">
              Tenure?
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["3 + 2 Years", "5 Years"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="tenure"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={tenure === status}
                    onChange={() => handleTenureChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="paymentMode" className="block font-medium">
              Payment Mode
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["UPI", "App", "NEFT/RTGS/IMPS", "ECS Mandate"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="paymentMode"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={paymentMode === status}
                    onChange={() => handlePaymentModeChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="propertyType" className="block font-medium">
              Property Rented / Owned
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["Rented", "Owned"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="propertyType"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={propertyType === status}
                    onChange={() => handlePropertyTypeChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="lease" className="block font-medium">
              Lease Duration
            </label>
            <input
              id="lease"
              name="lease"
              className="w-full border border-gray-300 rounded-lg p-2 mt-1"
              placeholder="Enter Lease Duration"
              value={lease}
              onChange={(e) => setLease(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="siteDetail" className="block font-medium">
              Site Details
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["New Site", "Existing Site"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="siteDetail"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={siteDetail === status}
                    onChange={() => handleSiteDetailChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label htmlFor="replacementNew" className="block font-medium">
              Replacement / New
            </label>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {["Replacement", "New", "Addition"].map((status) => (
                <label
                  key={status}
                  className="flex items-center space-x-3 text-medium"
                >
                  <input
                    type="radio"
                    name="replacementNew"
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                    checked={replacementNew === status}
                    onChange={() => handleReplacementNewChange(status)}
                  />
                  <span>{status}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="space-y-3">
            <label htmlFor="installationDate" className="block font-medium">
              Installation Date and Details
            </label>
            <input
              type="date"
              id="installationDate"
              name="installationDate"
              className="w-full border border-gray-300 rounded-lg p-2 mt-1"
              value={installationDate}
              onChange={(e) => setInstallationDate(e.target.value)}
              placeholder="Enter Installation Date"
              required
            />
            <textarea
              value={installationDetail}
              onChange={(e) => setInstallationDetail(e.target.value)}
              placeholder="Add your comments here..."
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
            ></textarea>
          </div>
          <div>
            <label className="block font-medium">Owner Details</label>
            <div className="flex">
              <div>
                <label htmlFor="ownerName" className="mb-2 font-name">
                  Name<span className="text-red-500">*</span>
                </label>
                <input
                  id="ownerName"
                  name="ownerName"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Owner Name"
                  value={ownerName}
                  onChange={(e) => setOwnerName(e.target.value)}
                  required
                />
              </div>
              <div className="mx-2">
                <label htmlFor="ownerNumber" className="mb-2 font-name">
                  Number<span className="text-red-500">*</span>
                </label>
                <input
                  id="ownerNumber"
                  name="ownerNumber"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Contact Number"
                  value={ownerNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numbers and restrict length to 10
                    if (/^\d{0,10}$/.test(value)) {
                      setOwnerNumber(value);
                    }
                  }}
                  required
                />
              </div>
            </div>
          </div>
          <div>
            <label className="block font-medium">Billing Details</label>
            <div className="flex">
              <div>
                <label htmlFor="newBillingnamee" className="mb-2 font-name">
                  Billing Name
                </label>
                <input
                  id="newBillingname"
                  name="newBillingname"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Billing Name"
                  value={newBillingName}
                  onChange={(e) => setnewBillingname(e.target.value)}
                  required
                />
              </div>
              <div className="mx-2">
                <label htmlFor="newgst" className="mb-2 font-name">
                  Gst Number
                </label>
                <input
                  id="newgst"
                  name="newgst"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter GST Number"
                  value={newGst}
                  onChange={handleGstChange}
                  required
                />
                {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
              </div>
            </div>
          </div>
          <div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="sameAsManager"
                checked={isSameAsManager}
                onChange={handleCheckboxChange1}
                className="mr-2 accent-primary border-2 border-primary rounded focus:ring-primary"
              />
              <label
                htmlFor="sameAsManager"
                className="ml-2 text-md text-gray-700"
              >
                Use Owner as Manager
              </label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="sameAsFinanceManager"
                checked={isSameAsFinanceManager}
                onChange={handleCheckboxChange2}
                className="mr-2 accent-primary border-2 border-primary rounded focus:ring-primary"
              />
              <label
                htmlFor="sameAsFinanceManager"
                className="ml-2 text-md text-gray-700"
              >
                Use Owner as Finance Manager
              </label>
            </div>
          </div>
          <div>
            <label className="mb-2 font-medium">Manager Details</label>
            <div className="flex">
              <div>
                <label htmlFor="managerName" className="mb-2 font-name">
                  Name
                </label>
                <input
                  id="managerName"
                  name="managerName"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Manager Name"
                  value={managerName}
                  onChange={(e) => setManagerName(e.target.value)}
                />
              </div>
              <div className="mx-2">
                <label htmlFor="managerNumber" className="mb-2 font-name">
                  Number
                </label>
                <input
                  id="managerNumber"
                  name="managerNumber"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Contact Number"
                  value={managerNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numbers and restrict length to 10
                    if (/^\d{0,10}$/.test(value)) {
                      setManagerNumber(value);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <label className="mb-2 font-medium">Finance Manager Details</label>
            <div className="flex">
              <div>
                <label htmlFor="financeManagerName" className="mb-2 font-name">
                  Name
                </label>
                <input
                  id="financeManagerName"
                  name="financeManagerName"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Finance Manager Name"
                  value={financeManagerName}
                  onChange={(e) => setFinanceManagerName(e.target.value)}
                />
              </div>
              <div className="mx-2">
                <label
                  htmlFor="financeManagerNumber"
                  className="mb-2 font-name"
                >
                  Number
                </label>
                <input
                  id="financeManagerNumber"
                  name="financeManagerNumber"
                  className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                  placeholder="Enter Contact Number"
                  value={financeManagerNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numbers and restrict length to 10
                    if (/^\d{0,10}$/.test(value)) {
                      setFinanceManagerNumber(value);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center">
            {isLoading && (
              <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
                <LoadingAnimation />
              </div>
            )}
            <button
              className="bg-white text-primary py-2 px-4 border border-primary m-1 md:m-0 "
              onClick={saveVerificationDetails}
            >
              {isUpdate ? "Update Details" : "Save Details"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationForm;
